<template>
    <span v-if="isTestEnv" class="env-banner">
        {{ t('Test environment') }}
    </span>
</template>

<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';

const { t } = useI18n();

const isTestEnv = computed(() => ['test', 'debug'].includes(window.appEnv));
</script>

<style scoped>
.env-banner {
    display: inline-block;
    background-color: #ffc107;
    color: #000;
    font-weight: bold;
    padding: 0.25em 0.75em;
    border-radius: 0.25rem;
    white-space: nowrap;
}
</style>
